<div
  [class]="alertClass"
  class="align-items-center d-flex justify-content-between p-2 w-100">
  <p class="message text-center w-100">{{ message }}</p>
  <button mat-icon-button (click)="closeAlert()" *ngIf="!data?.hideClose">
    <span cdkIcon="outlined">close</span>
  </button>
</div>
